/* eslint-disable no-useless-escape */

const devExtremeLicenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjU5OWVmNjU5LWM5OTYtMTFlNC04MGNlLTAwMTU1ZDYyNDgwYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.hzhWvwU9YQ2xXXhO9L873pku1oVqcBkAYU1ZlKKDHpYFtcc+MGF20+2VfOh3S/VQ+K9UfNlMv+0ruL40WnOqYNGmTVDJngmDUiTv0sXkOk7MyCeRZrzN+FVy+mrZxu6yuOnGBA==";

export const getExecutePopupHtml = ({
  result,
  popupColumns,
  queryType,
  totalCount,
  pageSize,
  executePayload,
  apiUrl,
  domain,
  jwtToken,
  gUserId,
  exportApiUrl,
}) => `
<html>
<head>
  <title>Query Results</title>

  <link rel="stylesheet" href="https://cdn3.devexpress.com/jslib/24.2.14/css/dx.light.css">

  <script src="https://code.jquery.com/jquery-3.7.1.min.js"><\/script>
  <script src="https://cdn3.devexpress.com/jslib/24.2.14/js/dx.all.js"><\/script>

  <style>
    html,
body {
  height: 100%;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
   .header {
  background: #111827;
  color: white;
  padding: 10px 18px;
  border-radius: 8px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
  .header h2 {
  margin: 0;
  font-size: 22px;
}

.header p {
  margin: 4px 0 0 0;
  font-size: 14px;
}

    .message {
      padding: 5px;
      border: 1px solid #b6d9ff;
      background: #eef7ff;
      margin-bottom: 10px;
      border-radius: 4px;
      flex-shrink: 0;
    }

      #resultsGrid {
  flex: 1;
  min-height: 0;
}
    .header button {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.header select {
  padding: 7px 10px;
  font-size: 14px;
  border-radius: 6px;
}

.header label {
  font-size: 15px;
  font-weight: 600;
  padding-top: 8px !important;
}

.dx-header-filter-menu .dx-list-search {
  height: 40px !important;
}

.dx-header-filter-menu .dx-searchbox {
  height: 36px !important;
}

.dx-header-filter-menu .dx-popup-content {
  padding: 10px !important;
}

.dx-header-filter-menu .dx-list {
  max-height: 220px !important;
}

.dx-header-filter-menu .dx-list-select-all {
  display: none !important;
}
.export-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.export-box {
  background: white;
  padding: 24px 32px;
  border-radius: 10px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 14px;
  pointer-events: auto;
}

.spinner {
  width: 26px;
  height: 26px;
  border: 4px solid #d1d5db;
  border-top: 4px solid #111827;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
  </style>
</head>

<body>

<div class="header">
  <div>
    <h2>Query Results</h2>
    <p>
  ${queryType} — Total Count:
  <span id="queryTotalCount">${totalCount}</span>
</p>
  </div>

  <div style="display:flex; gap:10px;">
    <button onclick="downloadExport()">Export</button>

    <label>Export File Type</label>
    <select id="exportFileType">
    <option value="EXCEL">Excel</option>
      <option value="CSV">CSV</option>
      <option value="PDF">PDF</option>
      
    </select>

    <button onclick="window.close()">Close</button>
  </div>
</div>

<div class="message">Results loaded.</div>
<div id="exportLoader" class="export-overlay" style="display:none;">
  <div class="export-box">
    <div class="spinner"></div>
    <div>Exporting data, please wait...</div>
  </div>
</div>
<div id="resultsGrid"></div>
<script>
DevExpress.config({
    licenseKey: "${devExtremeLicenseKey}"
  });
const executePayload = ${JSON.stringify(executePayload).replace(/</g, "\\u003c")};
const apiUrl = "${apiUrl}";
const exportApiUrl = "${exportApiUrl}";
const domain = "${domain}";
const jwtToken = "${jwtToken}";
const gUserId = "${gUserId}";
  const rows = ${JSON.stringify(result).replace(/</g, "\\u003c")};
function formatDateValue(value) {
  if (!value) return "";

  const date = new Date(value);

  if (isNaN(date.getTime())) return value;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return month + "/" + day + "/" + year;
}

const popupColumns = ${JSON.stringify(popupColumns).replace(/</g, "\\u003c")}.map(col => {
    const fieldText = ((col.dataField || "") + " " + (col.caption || "")).toLowerCase();

  const isDateColumn =
    fieldText.includes("date") ||
    fieldText.includes("dob") ||
    fieldText.includes("birth") ||
    fieldText.includes("sentence");

  return {
    ...col,

    customizeText: isDateColumn
      ? function(cellInfo) {
          return formatDateValue(cellInfo.value);
        }
      : undefined,

    headerFilter: {
      search: {
        enabled: true
      },
      dataSource: function(options) {
        options.dataSource.postProcess = function(items) {
          return items.filter(item => {
            const value = item.value;
            const text = item.text;

            const isBlankText =
              text === null ||
              text === undefined ||
              String(text).trim() === "";

            const isBlankValue =
              value === null ||
              value === undefined ||
              value === "" ||
              String(value).trim() === "";

            return !isBlankText && !isBlankValue;
          });
        };
      }
    }
  };
});
  function getFileConfig(format) {
  switch (format) {
    case "PDF":
      return {
        fileName: "QueryResults.pdf",
        mimeType: "application/pdf"
      };

    case "EXCEL":
    case "Excel":
      return {
        fileName: "QueryResults.xlsx",
        mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };

    case "CSV":
    default:
      return {
        fileName: "QueryResults.csv",
        mimeType: "text/csv;charset=utf-8;"
      };
  }
}

function base64ToBlob(base64, contentType) {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}

function setExportLoading(isLoading) {
  const loader = document.getElementById("exportLoader");
  const exportButton = document.querySelector(".header button");

  if (loader) loader.style.display = isLoading ? "flex" : "none";
  if (exportButton) exportButton.disabled = isLoading;
}

function downloadExport() {
  const selectedFormat = document.getElementById("exportFileType").value;
  const config = getFileConfig(selectedFormat);

  setExportLoading(true);

  fetch(exportApiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + jwtToken,
      "Domain": domain,
      "gUserId": gUserId
    },
    body: JSON.stringify({
      ...executePayload,
      exportFormat: selectedFormat,
      columns: popupColumns.map(col => ({
        fieldName: col.dataField,
        friendlyLabel: col.caption || col.dataField
      }))
    })
  })
    .then(async response => {
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Export failed");
      }

      const contentType = response.headers.get("content-type") || "";

      if (contentType.includes("application/json")) {
        const json = await response.json();

        const blob = base64ToBlob(
          json.base64FileContent,
          json.contentType || config.mimeType
        );

        return {
          blob,
          fileName: json.fileName || config.fileName
        };
      }

      const blob = await response.blob();

      return {
        blob,
        fileName: config.fileName
      };
    })
    .then(({ blob, fileName }) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.error("Export error", error);
      alert("Export failed.");
    })
    .finally(() => {
      setExportLoading(false);
    });
}

function convertFilterCondition(condition) {
  if (!Array.isArray(condition) || condition.length < 2) {
    return [];
  }

  const field = condition[0];
  const dxOperator = condition[1];
  const value = condition[2];

  const operatorMap = {
    "=": "equals",
    "<>": "notEquals",
    "contains": "contains",
    "notcontains": "notContains",
    "startswith": "startsWith",
    "endswith": "endsWith",
    ">": "greaterThan",
    ">=": "greaterThanOrEqual",
    "<": "lessThan",
    "<=": "lessThanOrEqual"
  };

  const operator = operatorMap[dxOperator];

  if (!operator || typeof field !== "string") {
    throw new Error("Unsupported grid filter: " + JSON.stringify(condition));
  }

  return [{
    logic: "AND",
    field: field,
    operator: operator,
    value: value,
    value2: null
  }];
}

function convertDevExtremeFilter(filter) {
  if (!filter || !Array.isArray(filter)) {
    return [];
  }

  // Simple filter: ["SGenderName", "=", "Male"]
  if (typeof filter[0] === "string" && filter.length >= 3) {
    return convertFilterCondition(filter);
  }

  // Combined filters
  const result = [];
  let nextLogic = "AND";

  for (const part of filter) {
    if (part === "and" || part === "or") {
      nextLogic = part.toUpperCase();
      continue;
    }

    if (!Array.isArray(part)) {
      throw new Error("Unsupported filter expression.");
    }

    const converted = convertDevExtremeFilter(part);

    converted.forEach((item, index) => {
      result.push({
        ...item,
        logic: result.length === 0
          ? "AND"
          : index === 0
            ? nextLogic
            : item.logic
      });
    });
  }

  return result;
}

  $("#resultsGrid").dxDataGrid({
  height: "100%",
    dataSource: new DevExpress.data.CustomStore({
  load: function(loadOptions) {

    const take = loadOptions.take || executePayload.pageSize || 25;
    const skip = loadOptions.skip || 0;
    const page = Math.floor(skip / take) + 1;

    let gridFilters = [];

    try {
      gridFilters = convertDevExtremeFilter(loadOptions.filter);
    } catch (error) {
      return Promise.reject(error);
    }

    // Preserve Query Builder filters and add popup filters.
    const existingFilters = executePayload.filters || [];

    const combinedFilters = [
      ...existingFilters,
      ...gridFilters
    ];

    // Convert DevExtreme sorting into QueryBuilder sorting.
    const gridSort = (loadOptions.sort || []).map(item => ({
      field: item.selector,
      direction: item.desc ? "desc" : "asc"
    }));

    const payload = {
      ...executePayload,
      page: page,
      pageSize: take,
      includeTotalCount: true,
      filters: combinedFilters,
      sort: gridSort.length > 0
        ? gridSort
        : (executePayload.sort || [])
    };

    return fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + jwtToken,
        "Domain": domain,
        "gUserId": gUserId
      },
      body: JSON.stringify(payload)
    })
    .then(async response => {
      if (!response.ok) {
        throw new Error(await response.text());
      }
      return response.json();
    })
    .then(response => {

      const rawRows =
        response.rows ||
        response.Rows ||
        response.data ||
        response.Data ||
        [];

      const count = response.totalCount ?? response.TotalCount;

      if (count == null) {
        throw new Error("API did not return totalCount.");
      }

      // Preserve raw field values for filtering and sorting.
      // Date display formatting is handled by popupColumns.
      const formattedRows = rawRows.map(row => ({ ...row }));

      // Update header with filtered count.
      const countElement = document.getElementById("queryTotalCount");

      if (countElement) {
        countElement.textContent = count;
      }

      return {
        data: formattedRows,
        totalCount: count
      };
    });
  }
}),
remoteOperations: {
  paging: true,
  filtering: true,
  sorting: true
},
    columns: popupColumns,
    showBorders: true,
    columnAutoWidth: true,
    rowAlternationEnabled: true,

    paging: { enabled: true, pageSize: ${pageSize || 10} },
    pager: {
      visible: true,
      showPageSizeSelector: true,
      allowedPageSizes: [25, 50, 100,250,500],
      showNavigationButtons: true,
      showInfo: true
    },

    // filterRow: { visible: true },
    headerFilter: {
  visible: true,
  search: {
    enabled: true
  },
  texts: {
    emptyValue: "(Blanks)"
  }
},
    searchPanel: { visible: true }
  });

<\/script>

</body>
</html>
`;
